import * as React from "react";
import ImgIconDatapro from '../../assets/datapro_d.png'

function CompanyFooter() {
  return (
    <footer className="flex gap-4 items-center max-sm:flex-col max-sm:items-start">
      <p className="text-lg text-gray-400 max-sm:text-base">
        a product of
      </p>
      <div className="flex gap-3 items-center">
        <div className="w-8 h-8 text-xl font-bold text-white bg-teal-600 rounded flex items-center justify-center">
          <img src={ImgIconDatapro} alt="Datapro logo" />
        </div>
        <h3 className="text-2xl font-semibold text-teal-600 max-sm:text-xl">
          Datapro Digital Solusi
        </h3>
      </div>
    </footer>
  );
}

export default CompanyFooter;
